import axios from "../assets/api/serve.js";

//获取地区名称
export function getRegionNames(ID) {
	return axios.get(`/portal/gov/getOrgArea/${ID}`)
}

//大数据获取溯源企业
export function enterprise(params) {
	return axios.get('/portal/gov/suyuan/org', {
		params: params
	})
}

//大数据获取码的情况
export function getOrgcodeData(params) {
	return axios.get(`/portal/gov/getOrgcodedata?${params}`)
}

//大数据产品分类情况
export function getDataCategory(params) {
	return axios.get(`/portal/gov/getDataCategory?${params}`)
}

//根据id查询相关企业
export function getCommpany(Id) {
	return axios.get(`/portal/data/getCommpany/${Id}`)
}

/*
 *天气相关接口start
 */
export function getLatAndLngByAddress(params) {
	return axios.get(`/portal/third/weather/getLatAndLngByAddress/${params}`)
}

export function briefcondition(params) {
	return axios({
		headers: {
			"Content-Type": "application/json"
		},
		url: "/portal/third/weather/briefcondition",
		method: "POST",
		data: params
	})
}

export function weather(params) {
	return axios({
		headers: {
			"Content-Type": "application/json"
		},
		url: "/portal/third/weather/aqi",
		method: "POST",
		data: params
	})
}

export function briefforecast6days(params) {
	return axios({
		headers: {
			"Content-Type": "application/json"
		},
		url: "/portal/third/weather/briefforecast6days",
		method: "POST",
		data: params
	})
}
/*
 *天气相关接口end
 */

//气象站数据
export function meteorologicalData(params) {
	return axios.get(`/device/weatherdevicedata/modbus/slave/config?${params}`,{
		// headers: {
		//     Authorization:
		//       localStorage.getItem("token_type") +
		//       localStorage.getItem("access_token")
		// }
	})
}
